import {STATUS} from '@binotel-frontend/bnt-common-components';
import {EMPTY_PAGINATOR} from '@entities/api';
import {createFeature, createReducer, on} from '@ngrx/store';
import {getApiActionReducersPaginated} from '@utils/get-api-action-reducers-paginated.function';

import {SearchActions} from './search.actions';
import {ISearchState} from './search-state.interface';

const searchFeatureKey = 'searchFeature';

const initialState: ISearchState = {
  subjects: [],
  subjectsLoadingStatus: STATUS.default,
  subjectsPagination: EMPTY_PAGINATOR,
};

const searchReducer = createReducer(
  initialState,
  ...getApiActionReducersPaginated<ISearchState>()(
    SearchActions.searchSubjects,
    'subjects'
  ),
  on(
    SearchActions.clearSubjects,
    (state): ISearchState => ({
      ...state,
      subjects: [],
    })
  ),
  on(SearchActions.clearSearch, (): ISearchState => initialState)
);

export const searchFeature = createFeature({
  name: searchFeatureKey,
  reducer: searchReducer,
});
